<template>
    <div class="page">
        <video controls ref="video">
            <source :src="url" type="video/mp4">
        </video>
    </div>
</template>
<script>
export default {
    data() {
        return {
            spotid: '',
            url: '',
            data: [
                {spotid:311817, url: 'https://filewc.geeker.com.cn/jpjs/video/emei/t01.mp4'},
                {spotid:311818, url: 'https://filewc.geeker.com.cn/jpjs/video/emei/t02.mp4'},
                {spotid:311819, url: 'https://filewc.geeker.com.cn/jpjs/video/emei/t03.mp4'},
                {spotid:311820, url: 'https://filewc.geeker.com.cn/jpjs/video/emei/t04.mp4'},
                {spotid:311821, url: 'https://filewc.geeker.com.cn/jpjs/video/emei/t05.mp4'}
            ]
        }
    },
    created() {
      this.spotid = this.$route.query.spotid;
      this.init()
    },
    methods: {
        init() {
            for (let item of this.data) {
                if (item.spotid == this.spotid) {
                    this.url = item.url;
                    return;
                }
            }
        }
    }
}
</script>
<style scoped>
video {
  width: 100%;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/page/video-vr/video-play.vue